// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sport1CondensedBlackItalic_3ff9ce', Sport1-CondensedBlackItalic-Fallback"},"className":"__className_3ff9ce"};